import StoreLocatorMap from "./StoreLocatorMap";

const GoogleMap = {
  StoreLocatorMap,
};

export { default as StoreLocatorMap } from "./StoreLocatorMap";
export default GoogleMap;



// WEBPACK FOOTER //
// ./src/component/GoogleMap/index.js